import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { NumberFixed } from '@delmonicos/shared-design-system-react/src/components/number-fixed/number-fixed';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useCpmsBoGetEnergyDeliveredQuery } from '@service/cpms-bo-transaction-reports-energy-statistics.service';

import { useFilters } from '../../context/filters.context';
import * as css from '../../statistics.module.scss';

export const EnergyDeliveredCard = (): React.JSX.Element => {
  const { t } = useTranslation();

  const { transformedFilters } = useFilters();

  const { data } = useCpmsBoGetEnergyDeliveredQuery({ ...transformedFilters });

  return (
    <Card gap={GapEnum.M} flex={1}>
      <AccentTitle
        variant={AccentVariantEnum.Secondary}
        icon="lightning-02"
        text={t('$.statistics.energy.delivered.title')}
      />
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedSecondary])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Stack
          alignItems="center"
          gap={GapEnum.XS}
          flex={1}
          justifyContent="flex-start">
          <Text fontSize={TextFontSize.Large}>
            {t('$.statistics.energy.delivered.average')}
          </Text>
          <Text fontSize={TextFontSize.Medium} color={TextColor.Secondary}>
            {t('$.statistics.energy.delivered.by-transaction')}
          </Text>
        </Stack>
        <NumberFixed
          bold
          fontSize={TextFontSize.Large}
          number={data?.average ?? 0}
          digits={0}>
          <Text>{t('$.statistics.energy.delivered.unit')}</Text>
        </NumberFixed>
      </Stack>
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedSecondary])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Text fontSize={TextFontSize.Large}>
          {t('$.statistics.energy.delivered.minimum')}
        </Text>
        <NumberFixed
          bold
          fontSize={TextFontSize.Large}
          number={data?.minimum ?? 0}
          digits={0}>
          <Text>{t('$.statistics.energy.delivered.unit')}</Text>
        </NumberFixed>
      </Stack>
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedSecondary])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Text fontSize={TextFontSize.Large}>
          {t('$.statistics.energy.delivered.maximum')}
        </Text>
        <NumberFixed
          bold
          fontSize={TextFontSize.Large}
          number={data?.maximum ?? 0}
          digits={0}>
          <Text>{t('$.statistics.energy.delivered.unit')}</Text>
        </NumberFixed>
      </Stack>
    </Card>
  );
};
